// Define fields to validate for each step
export const stepFields: Array<keyof ICheckoutForm>[] = [
  [
    "firstName",
    "lastName",
    "email",
    "streetAddress",
    "city",
    "zipCode",
    "idCountry",
    "idState",
    "phoneNumber",
  ],
  ["shippingMethod"],
  ["number", "expiry", "cvc", "cardholder"],
];
